import { Divider } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import React from "react";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { sessionLogout } from "../../../utils/sessionLogout";
import { SESSION_LOGOUT_REASON_MANUAL } from "../../../utils/session.constants";

const UserMenu = () => {
  const navigate = useNavigate();
  const classes = useStyles();
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  if (!isAuthenticated || accounts.length === 0) return null;

  // Get user name from MSAL account
  const name = accounts[0].name || accounts[0].username || "User";

  const handleSignOut = () => {
    sessionLogout(instance, accounts[0], {
      reason: SESSION_LOGOUT_REASON_MANUAL,
      broadcast: true,
    });
  };

  return (
    <Container>
      <Select
        className={classes.root}
        disableUnderline
        value={name.toUpperCase()}
        inputProps={{ classes: { icon: classes.icon } }}
        renderValue={(selected) => (
          <div className={classes.selectLabel}>
            <span>{selected.charAt(0).toUpperCase() + selected.slice(1)}</span>
          </div>
        )}
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          getContentAnchorEl: null,
        }}
      >
        <MenuItem
          onClick={(e) => {
            e.preventDefault();
            navigate(`/ctpo/admin-data/`);
          }}
          value="admin"
        >
          Admin Data
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={(e) => {
            e.preventDefault();
            navigate(`/ctpo/user-profile/`);
          }}
          value="userProfile"
        >
          User Profile
        </MenuItem>
        <Divider />

        <MenuItem onClick={handleSignOut}>
          Sign Out
        </MenuItem>
      </Select>
    </Container>
  );
};

export default UserMenu;

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const useStyles = makeStyles((theme) => ({
  avatar: { color: "#cada2a", marginRight: theme.spacing(1) },
  root: {
    color: "var(--White) !important",
    fontSize: "15px",
    "&:hover": {
      opacity: 0.8,
    },
    "& .MuiMenuItem-root": {
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
        color: theme.palette.common.white,
      },
    },
  },
  icon: {
    color: "var(--White)",
  },
  selectLabel: {
    display: "flex",
    alignItems: "center",
    fontSize: "15px",
  },
}));